// utils/exportPaymentsToExcel.js
import * as XLSX from "xlsx";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);

  return Number.isNaN(date.getTime())
    ? ""
    : date.toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
};

const formatCurrency = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const exportPaymentsToExcel = (payments, fileName = "payments") => {
  if (!payments?.length) {
    console.warn("No payments to export");
    return;
  }

  const rows = payments.map((p) => ({
    "Code #": p.receiptNumber || "",
    Reference: p.reference || "",
    "Invoice #": p.invoiceNumber || "",
    Direction: p.direction || "",
    Type: p.type || "",
    Method: p.method || "",
    Status: p.status || "",
    Amount: formatCurrency(p.amount),
    "Bank Commission": formatCurrency(p.bankCommission),
    CreateAt: formatDate(p.date),
    "Payment Date": formatDate(p.paymentDate),
    Branch: p.branchName || "",
    "IRN /FSN #": p.irn || "",
    "RRN /Receipt #": p.rrn || "",
    Description: p.description || "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const headers = Object.keys(rows[0]);
  const range = XLSX.utils.decode_range(worksheet["!ref"]);

  // Format monetary columns as numeric Excel cells.
  ["Amount", "Bank Commission"].forEach((column) => {
    const colIndex = headers.indexOf(column);

    for (let row = 1; row <= range.e.r; row++) {
      const address = XLSX.utils.encode_cell({
        r: row,
        c: colIndex,
      });

      const cell = worksheet[address];

      if (cell) {
        cell.t = "n";
        cell.z = "#,##0.00";
      }
    }
  });

  worksheet["!cols"] = headers.map((key) => ({
    wch: Math.max(key.length, 14),
  }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");

  const timestamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(workbook, `${fileName}_${timestamp}.xlsx`);
};
